import { OrderType } from '../store/order/model';
import { OrderEventProperties } from './analytics-events';

/** A numeric id from a route parameter or API string, or unset when it isn't one. */
export function toAnalyticsId(value: string | number | undefined | null): number | undefined {
    const id = Number(value);
    return value !== undefined && value !== null && value !== '' && Number.isInteger(id)
        ? id
        : undefined;
}

/**
 * The order an order-screen event is about: its id, its firm (so `track()` counts the event under
 * that firm, like the server's events) and whether it's a buy or maintenance order.
 */
export function orderEventProperties(
    order: { id: string; firm?: { id: string } | null },
    orderType: OrderType
): OrderEventProperties {
    return {
        order_id: order.id,
        firm_id: toAnalyticsId(order.firm?.id),
        order_type: orderType
    };
}
